import TalentXDashboard from './TalentXDashboard.component';

export default TalentXDashboard;
